export const getTimeAgo = (timestamp: Date): string => {
  const now = new Date();
  const diffInMs = now.getTime() - timestamp.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

  if (diffInDays > 365) {
    const years = Math.floor(diffInDays / 365);
    return `${years} år sedan`;
  } else if (diffInDays > 30) {
    const months = Math.floor(diffInDays / 30);
    return `${months} månad${months > 1 ? "er" : ""} sedan`;
  } else if (diffInDays > 0) {
    return `${diffInDays} dag${diffInDays > 1 ? "ar" : ""} sedan`;
  } else if (diffInHours > 0) {
    return `${diffInHours} timm${diffInHours > 1 ? "ar" : "e"} sedan`;
  } else if (diffInMinutes > 0) {
    return `${diffInMinutes} minut${diffInMinutes > 1 ? "er" : ""} sedan`;
  } else {
    return "Just nu";
  }
};
